/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

        //option for user to exit out of the mini cart when they click the black opacity space outside of the window
         $(document).on('click', '.ajax-cart, .ajax-cart--mini-cart, .theme-ajax-cart, .mini_cart__remove', function(e) {
          e.stopPropagation();
        });      
        // Handle clicks on cart trigger
        $(document).on('click', '[data-ajax-cart-trigger]', function(e) {
          e.stopPropagation();
        });
        // Handle clicks outside mini-cart (on document)
        $(document).on('click', function(e) {
          // Only proceed if mini cart is open
          if (!$('body').hasClass('body-show-mini-cart')) {
            return;
          }
      
          // Get clicked element
          const clickedElement = $(e.target);
          
          // Check if click is outside mini-cart and its trigger
          const isOutsideMiniCart = !clickedElement.closest('.ajax-cart, .ajax-cart--mini-cart, .mini_cart__remove').length &&
                                   !clickedElement.closest('[data-ajax-cart-trigger]').length;
      
          // If clicking outside, close the mini cart
          if (isOutsideMiniCart) {
            window.PXUTheme.jsAjaxCart.hideMiniCart();
          }
        });



    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '#confirm-understood', function (e) {
      e.preventDefault();
      const $addToCartForm = $('.product_form').find('form');
      const $button = $(this);
      $('#confirm-understood').addClass('clicked');
      $button.text('ADDED');
      $button.prop('disabled', true);
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    // Listen for the close event and apply CSS
    $(document).one('afterClose.fb', function () {
      $('.button--add-to-cart').css({
        'color': '#ffffff',
        'background-color': '#000000',
        'border-color': '#000000'
      }).blur().trigger('mouseout'); // Optional: reset hover state
    });


    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-mini-cart-page-delete]', function (e) {
      const $removeButton = $(this);
      const $lineItem = $removeButton.closest('.cart__item');
      const EXTRA_PRODUCT_ID = 8806950863061;
    
      // Find the product ID of the line item being removed
      const removedLineItemProductId = $lineItem.find('[data-product-id]').data('product-id');
      const isExtraProductLineItemRemoved = removedLineItemProductId === EXTRA_PRODUCT_ID;
    
      // Perform cart update after a longer, more reliable timeout
      setTimeout(() => {
        // Use Shopify's cart endpoint directly to get the most up-to-date cart
        fetch('/cart.js', { method: 'GET' })
          .then(response => response.json())
          .then(cart => {
            // Check if the extra product is no longer in the cart
            const extraProductRemoved = !cart.items.some(item => item.id === EXTRA_PRODUCT_ID);
            const shouldClearProperty = extraProductRemoved || isExtraProductLineItemRemoved;
    
            if (shouldClearProperty) {
              // Find the original product with personalization
              const originalProductInCart = cart.items.find(item => 
                item.properties && 
                item.properties['Personalized Buckle Engraving']
              );
    
              if (originalProductInCart) {
                // Use fetch for more modern AJAX handling
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: originalProductInCart.key,
                    properties: {
                      'Personalized Buckle Engraving': ''
                    }
                  })
                })
                .then(response => response.json())
                .then(() => {
                  // Update cart view
                  if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
                    window.PXUTheme.jsAjaxCart.updateView();
                  }
    
                  // Reset input fields and personalization state
                  $('input[name="conf_init"]').val('');
                  $('input[name="properties[Personalized Buckle Engraving]"]').val('');
                  $('input[name="show_info"]').prop('checked', false);
                })
                .catch(error => {
                  console.error('Error clearing personalization:', error);
                });
              }
            }
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
          });
      }, 500); // Increased timeout to 500ms for more reliable cart state
    });

    

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });
  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        // $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        // $('body').addClass('body-show-mini-cart');
      } else {
        // $el.addClass('show-mini-cart');
        // $('body').addClass('body-show-mini-cart');
      }
    }, function() {
      // $el.removeClass('show-mini-cart');
      // $('body').removeClass('body-show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    // $el.removeClass('show-mini-cart');
    $('body').removeClass('body-show-mini-cart');
    $('.has-shadow').hide();
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
      $('body').toggleClass('body-show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },

  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },

 addToCart: function ($addToCartForm) {
    const variantIdRaw = $addToCartForm.find('[name="id"]').val();
    const $productFormRoot = $addToCartForm.closest('.product_form');
    if (
      $productFormRoot.length
      && typeof window.PXUTheme.variantBlockedByHideSize === 'function'
      && window.PXUTheme.variantBlockedByHideSize($productFormRoot[0], variantIdRaw)
    ) {
      const sold = window.PXUTheme.translation && window.PXUTheme.translation.soldOut;
      if (sold) {
        $addToCartForm.find('.cart-warning').html(
          '<p class="cart-warning__message animated fadeIn">' + sold + '</p>',
        );
      }
      return;
    }

    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
   
    // Check if 'show_info' radio button is checked
    const isInfoRadioChecked = document.getElementsByName('show_info')[0]?.checked || false;
    
    // Get the initial value of 'Personalized Buckle Engraving'
    const initial1Value = document.getElementsByName('conf_init')[0]?.value || "";
    
    // Get the initial value of 'conf_init'
    const initial2Value = document.getElementsByName('properties[Personalized Buckle Engraving]')[0]?.value || "";

   const credentialsMet = isInfoRadioChecked && initial1Value && initial2Value && (initial1Value === initial2Value);

   const productId= document.querySelector(".product_form").dataset['productId'];

    // Store the original form data
    const originalFormData = $addToCartForm.serialize();
   
    const button = document.getElementById("confirm-understood");

    if (isInfoRadioChecked) {
        // Validation checks
        let errorMessage = '';
            
      if (!initial1Value) {
        errorMessage = 'Please enter your initials.';
      } else if (!/^[A-Za-z]{1,4}$/.test(initial1Value)) {
        errorMessage = 'Initials must contain only up to 4 alphabetic characters.';
      } else if (!initial2Value) {
        errorMessage = 'Please confirm your initials.';
      } else if (!/^[A-Za-z]{1,4}$/.test(initial2Value)) {
        errorMessage = 'Confirmation initials must contain only up to 4 alphabetic characters.';
      } else if (initial1Value !== initial2Value) {
        errorMessage = 'The initials entered do not match. Please check and try again.';
      } 

      // If there are any validation errors, show message and return
      if (errorMessage) { 
        const cartWarning = `
          <p class="cart-warning__message animated fadeIn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            ${errorMessage}
          </p>`;
        const messageContainer = document.getElementById('message-container');
        messageContainer.style.display = 'none';
        $('.warning').remove();
        $addToCartForm
          .find('.cart-warning')
          .html(cartWarning);

        // Add a shake animation to draw attention
        $addToCartForm.find('.cart-warning__message').removeClass('shake').addClass('shake');
        
        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');

        return; // Stop execution if validation fails
      }
    }

    if ($addToCartBtn.hasClass('swatch-image-unavailable') && !button.classList.contains("clicked")) {
      console.log('in if');
      const $selectedInput = $addToCartForm.find('.swatch__option input[type="radio"]:checked');
      const $swatchOption = $selectedInput.closest('.swatch__option');
      const colorName = $selectedInput.attr('aria-label') || $selectedInput.val() || 'Selected Color';
      const swatchImg = $swatchOption.find('img.swatch__image').attr('src') || '';
    
      // Fill popup content
      $('#swatch-color-name').text(colorName);
      $('#swatch-color-image').attr('src', swatchImg);

      // $('#confirm-understood').prop('checked', false);
      button.textContent = "ADD TO CART";
      $('#confirm-understood').prop('disabled', false);
    
      // Store for later
      window._deferredAddToCartForm = $addToCartForm;
      window._deferredFormData = originalFormData;
    
      return; // Stop add to cart for now
    } else if ($addToCartBtn.hasClass('swatch-image-unavailable')) {
      console.log('in else if');
      button.classList.remove('clicked');
      setTimeout(function () {
        $.fancybox.close();
      }, 1000);
    }

    // Function to add additional product with specific ID
    const addExtraProduct = () => {
      const extraProductData = {
        items: [{
          id: 50630135316693,
          quantity: 1
        }]
      };

      return $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: extraProductData,
        success: function(product) {
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: function(XMLHttpRequest) {
          console.error('Error adding extra product:', XMLHttpRequest);
        }
      });
    };

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;
      $('.warning').remove();
      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      // Process cart addition based on credentials
      if (credentialsMet ) {
        // If credentials met, add both original and extra product
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: originalFormData,
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');

            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {
            // Add the extra product after successful addition of first product
            addExtraProduct();
            document.getElementById('initials1').value = ''; // Clear the value of the first input
            document.getElementById('initials2').value = '';
            const messageContainer = document.getElementById('message-container');
            messageContainer.style.display = 'none';
            const cartWarningMessage = document.querySelector('.cart-warning__message');
            if (cartWarningMessage) {
                cartWarningMessage.style.display = 'none';
            }
            const cartWarnings = document.querySelector('.cart-warning');
            if (cartWarnings) {
                cartWarnings.style.display = 'none';
            }
            const hideOnUncheckedDiv = document.querySelector('.hide_on_unchecked');
            const extraInfo = document.getElementById('extraInfo');
            const initialsInput1 = document.getElementById('initials1');
            const confirmButton1 = document.getElementById('confirmButton1');
            const initialsInput2 = document.getElementById('initials2');
            const confirmButton2 = document.getElementById('confirmButton2');
            const errorMessage = document.getElementById('error-message');
            // const messageContainer = document.getElementById('message-container');

            // hideOnUncheckedDiv.style.display = 'none';
            hideOnUncheckedDiv.classList.add('hidden');
            extraInfo.classList.add('hidden');
            initialsInput1.classList.add('hidden');
            confirmButton1.classList.add('hidden');
            initialsInput2.classList.add('hidden');
            confirmButton2.classList.add('hidden');
            errorMessage.style.display = 'none';
            initialsInput1.value = '';
            initialsInput2.value = '';
            messageContainer.style.display = 'none';
            messageContainer.innerHTML = '';

            const showInfo = document.getElementById('showInfoRadio');
            showInfo.checked = false;

            let $el = $('[data-ajax-cart-trigger]');
            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }

              $el.addClass('show-mini-cart');
              $('body').addClass('body-show-mini-cart');
              $('.has-shadow').show();

              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }

            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "html",
                async: false,
                cache: false,
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);
                }
              });
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

            $('.warning').remove();

            $addToCartForm
              .find('.cart-warning')
              .html(cartWarning);

            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          }
        });
      } else {
        // If credentials not met, process normal cart addition
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: originalFormData,
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');

            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {            
            let $el = $('[data-ajax-cart-trigger]');
            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }

              $el.addClass('show-mini-cart');
              $('body').addClass('body-show-mini-cart');
              $('.has-shadow').show();

              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }

            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "html",
                async: false,
                cache: false,
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);
                }
              });
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

            $('.warning').remove();

            $addToCartForm
              .find('.cart-warning')
              .html(cartWarning);

            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          }
        });
      }
    }
  },

  updateView: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {
      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        let isMiniCart = $('.show-mini-cart').length;
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        if (isMiniCart > 0) {
          window.PXUTheme.jsAjaxCart.hideDrawer();
          window.PXUTheme.jsAjaxCart.hideMiniCart();
          return false;
        }
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;